import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CrewStatus } from '../../api/scheduler/models/crew-status';
import { Rank } from '../../api/scheduler/models/rank';
import { Rotation } from '../../api/scheduler/models/rotation';
import { SchedulerCrewDto } from '../../api/scheduler/models/scheduler-crew-dto';
import { WingType } from '../../api/scheduler/models/wing-type';
import { PageMeta } from '../../api/scheduler/models/page-meta';

export const SCHEDULER_CREW_DEFAULT_PAGE_SIZE = 12;

export interface SchedulerCrewQuery {
  search: string;
  rotation: Rotation | '';
  rank: Rank | '';
  wingType: WingType | '';
  status: CrewStatus | '';
  sort: string;
  page: number;
  size: number;
}

export const DEFAULT_SCHEDULER_CREW_QUERY: SchedulerCrewQuery = {
  search: '',
  rotation: '',
  rank: '',
  wingType: '',
  status: '',
  sort: 'crewName,asc',
  page: 0,
  size: SCHEDULER_CREW_DEFAULT_PAGE_SIZE,
};

export const SchedulerCrewActions = createActionGroup({
  source: 'Scheduler Crew',
  events: {
    Load: props<{ query?: Partial<SchedulerCrewQuery>; append?: boolean }>(),
    'Set Search': props<{ search: string }>(),
    Reset: emptyProps(),
    'Load Success': props<{
      items: SchedulerCrewDto[];
      page: PageMeta | null;
      requestId: number;
    }>(),
    'Load Failure': props<{ error: string; requestId?: number }>(),
    Update: props<{
      id: number;
      rank: Rank;
      wingType: WingType;
      rotation: Rotation;
      previous: SchedulerCrewDto;
    }>(),
    'Update Success': props<{ id: number; crew: SchedulerCrewDto; requestId: number }>(),
    'Update Failure': props<{
      id: number;
      error: string;
      requestId: number;
      previous?: SchedulerCrewDto;
    }>(),
    'Update Status': props<{ id: number; status: CrewStatus; previous: SchedulerCrewDto }>(),
    'Update Status Success': props<{ id: number; crew: SchedulerCrewDto; requestId: number }>(),
    'Update Status Failure': props<{
      id: number;
      error: string;
      requestId: number;
      previous?: SchedulerCrewDto;
    }>(),
    'Set Card Error': props<{ id: number; error: string }>(),
    'Clear Card Error': props<{ id: number }>(),
  },
});
